import { TaskFilterInputObject, FilterGroupingEnum } from 'graphql-common';
import { TaskDuplicationWarningProps } from 'routes/Task/TaskDuplicationWarning/types';
import { AssignationsType } from 'routes/Task/enums';

const getAdditionalFilters = ({
  assignationsType,
  assetIds,
  siteAreaIds,
  taskName,
  templateVersionId,
}: TaskDuplicationWarningProps) => {
  if (!taskName || !templateVersionId) {
    return [];
  }

  const filters: TaskFilterInputObject[] = [];
  let hasPrimaryFilter = false;

  if (
    assignationsType === AssignationsType.Area &&
    siteAreaIds &&
    siteAreaIds.length
  ) {
    filters.push({
      siteAreaId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: siteAreaIds.map(String) },
      },
    });
    hasPrimaryFilter = true;
  }

  if (
    assignationsType === AssignationsType.Equipment &&
    assetIds &&
    assetIds.length
  ) {
    filters.push({
      assetId: {
        grouping: FilterGroupingEnum.And,
        predicate: { in: assetIds.map(String) },
      },
    });
    hasPrimaryFilter = true;
  }

  if (!hasPrimaryFilter) {
    return [];
  }

  if (taskName) {
    filters.push({
      name: {
        grouping: FilterGroupingEnum.And,
        predicate: { eq: taskName },
      },
    });
  }

  if (templateVersionId) {
    filters.push({
      templateVersionId: {
        grouping: FilterGroupingEnum.And,
        predicate: { eq: templateVersionId },
      },
    });
  }

  return filters;
};

export default getAdditionalFilters;
